export const PORTFOLIO = '/data/projects/portfolio.json';
export const SEND_EMAIL = 'https://us-central1-ferrericloud.cloudfunctions.net/sendEmail';


// WEBPACK FOOTER //
// ./src/constants/endpoints.js